import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { allowedLinks } from "@nxplatform/platform-settings/locale-setup.routes";
import { setRecommendGamesLang } from "@nxplatform/casino/casino-games-recommended.slice";
const useGameRecommendationByLangHook = ({
  auth,
  langIso,
  mainRecommendedNonAuthEnabled
}) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (!langIso || !mainRecommendedNonAuthEnabled) return;
    if (auth) {
      dispatch(setRecommendGamesLang(null));
      return;
    }
    if (pathname.includes(allowedLinks.casino) || pathname.includes(allowedLinks.liveCasino) || pathname === allowedLinks.home) {
      dispatch(setRecommendGamesLang(langIso.indexOf("_") > -1 ? langIso.split("_")[0] : langIso));
    }
  }, [auth, pathname, langIso, mainRecommendedNonAuthEnabled]);
};
export {
  useGameRecommendationByLangHook
};
